import { render, staticRenderFns } from "./Regularizar.vue?vue&type=template&id=10164216&lang=pug&"
import script from "./Regularizar.vue?vue&type=script&lang=js&"
export * from "./Regularizar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports